import { CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";
import { Button } from "../ui/button";
import { Calendar } from "../ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const DateFilterPicker = ({ label, testId, value, onChange }) => (
  <div>
    <label className="block text-[10px] font-bold uppercase tracking-wide text-midnight-black/50 mb-1">{label}</label>
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testId}
          className="w-40 justify-start text-left font-normal text-xs h-10 border-soft-gray"
        >
          <CalendarIcon className="mr-2 h-3.5 w-3.5 opacity-60" />
          {value ? format(new Date(`${value}T00:00:00`), "MMM d, yyyy") : "Any date"}
          {value && (
            <X
              className="ml-auto h-3.5 w-3.5 opacity-60 hover:opacity-100"
              data-testid={`${testId}-clear`}
              onClick={(e) => {
                e.stopPropagation();
                onChange("");
              }}
            />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value ? new Date(`${value}T00:00:00`) : undefined}
          onSelect={(date) => onChange(date ? format(date, "yyyy-MM-dd") : "")}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  </div>
);
